import { TID } from "@/constants/testIds";
import logoWhite from "@/assets/gbe-logo-white.png";
import logoBlue from "@/assets/gbe-logo-blue.png";

export function GBELogo({ className = "", withText = false, variant = "white", size = 40 }) {
  const src = variant === "white" ? logoWhite : logoBlue;
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid={TID.brandLogo}>
      <img
        src={src}
        alt="GBE Group"
        style={{ height: size }}
        className="w-auto shrink-0 select-none"
        draggable={false}
      />
      {withText && (
        <div className="leading-tight">
          <div className={`text-[10px] uppercase tracking-[0.18em] ${variant === "white" ? "text-white/70" : "text-gbe/70"}`}>
            Data Hub
          </div>
        </div>
      )}
    </div>
  );
}
